import { generatePath, useHistory } from 'react-router-dom';
import { t } from 'ttag';

import { contacts, privacyPolicy, secondaryPage, termsOfService } from '@urls';
import { getShafaAbsoluteUrl } from '@utils/common';
import { LayoutContainer } from '@ui/LayoutContainer';
import { Link } from '@ui/Link';

import s from './Footer.sss';

export const Footer: React.FC = () => {
  const history = useHistory();

  return (
    <footer className={s.root}>
      <LayoutContainer className={s.layout}>
        <section className={s.row}>
          <div className={s.column}>
            <p className={s.contacts}>
              {t`Україна, 02121, місто Київ, Харківське шосе, будинок 201-203, літера 4Г`}
            </p>
          </div>

          <div className={s.column}>
            <ul className={s.linksList}>
              <li className={s.linksItem}>
                <Link
                  theme="black"
                  className={s.link}
                  href={getShafaAbsoluteUrl(history.createHref({ pathname: privacyPolicy }))}
                >
                  {t`Політика конфіденційності`}
                </Link>
              </li>
              <li className={s.linksItem}>
                <Link
                  theme="black"
                  className={s.link}
                  href={getShafaAbsoluteUrl(history.createHref({ pathname: termsOfService }))}
                >
                  {t`Договір-оферта`}
                </Link>
              </li>
              <li className={s.linksItem}>
                <Link
                  theme="black"
                  className={s.link}
                  to={generatePath(secondaryPage, { slug: 'sposobi-oplati-zamovlennya' })}
                >
                  {t`Умови оплати`}
                </Link>
              </li>
              <li className={s.linksItem}>
                <Link
                  theme="black"
                  className={s.link}
                  to={generatePath(secondaryPage, { slug: 'sposobi-dostavki-zamovlennya-ta-yih-vartist' })}
                >
                  {t`Умови доставки`}
                </Link>
              </li>
              <li className={s.linksItem}>
                <Link
                  theme="black"
                  className={s.link}
                  to={generatePath(secondaryPage, { slug: 'usloviya-vozvrata-tovara' })}
                >
                  {t`Умови повернення`}
                </Link>
              </li>
              <li className={s.linksItem}>
                <Link
                  theme="black"
                  className={s.link}
                  to={contacts}
                >
                  {t`Контакти`}
                </Link>
              </li>
            </ul>
          </div>
        </section>
      </LayoutContainer>
    </footer>
  );
};
